/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_Mock_3_StateInputs */

const en_cap_money_mock_3_state = /** @type {(inputs: Cap_Money_Mock_3_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft prepared`)
};

const lv_cap_money_mock_3_state = /** @type {(inputs: Cap_Money_Mock_3_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melnraksts gatavs`)
};

/**
* | output |
* | --- |
* | "Draft prepared" |
*
* @param {Cap_Money_Mock_3_StateInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_mock_3_state = /** @type {((inputs?: Cap_Money_Mock_3_StateInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_Mock_3_StateInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_mock_3_state(inputs)
	return en_cap_money_mock_3_state(inputs)
});